$(document).on('click', 'label.boost-sd__radio-label', function() {
  var href = $(this).attr('data_href');
  location.href = href;
});

$(document).on('click', 'body .boost-sd__filter-tree-toggle-button--expand', function(e) {
  e.preventDefault();
  e.stopPropagation();
  if ($(this).hasClass('boost-sd__filter-tree-toggle-button--active')) {
    $(this).addClass('boost-sd__filter-tree-toggle-button--active');
  } else {
    $(this).removeClass('boost-sd__filter-tree-toggle-button--active');
  }
  $('.boost-sd__filter-tree-vertical').toggleClass('boost-sd__filter-tree-vertical--hidden');
});
$(document).ready(function() {
  
    $(document).on('click', '.muted_btn', function(e) {
      e.preventDefault();
      if ($(this).hasClass('sound_on')) {        
        $(this).removeClass('sound_on');
        $('video.videovideo_sound:visible').each( (i, el) => { 
          el.muted = false  
        });
      } else {
        $(this).addClass('sound_on');
        $('video.videovideo_sound:visible').each( (i, el) => { 
          el.muted = true  
        });
      }
    })
  
    $(document).on('click', '.play_btn', function(e) {
      e.preventDefault();
      if ($(this).hasClass('play_on')) {  
        $(this).removeClass('play_on');
        $('video.videovideo_sound:visible').each( (i, el) => { 
          el.pause();
        });      
      } else {
        $(this).addClass('play_on');
        $('video.videovideo_sound:visible').each( (i, el) => { 
          el.play();
        });
      }
    })
  
  	$('.item.mteam .small--meet-the-team').click(function() {
		$(this).parent().find('.modal-wrapper-team').addClass('open')
	});  
	$('.btn-close').click(function() {
		$('.modal-wrapper-team').removeClass('open');
        $(".modal-wrapper-team").attr("class", "modal-wrapper-team");
	});  
    $('.variant-input-wrap input[type=radio]:checked+label').parent('.variant-input').trigger('click');
});

$(document).on('mouseover', 'a.boost-sd__product-link .arne-color-swatch-element', function() {
    var newImageSrc = $(this).find('img').attr('src');
    $(this).parents('.boost-sd__product-item').find('.boost-sd__product-image').addClass('hoveractive');
    $(this).parents('.boost-sd__product-item').find('.onhover_metaimage').html('<img src="'+newImageSrc+'" />');
}).on('mouseout', 'a.boost-sd__product-link .arne-color-swatch-element', function() {
    $(this).parents('.boost-sd__product-item').find('.boost-sd__product-image').removeClass('hoveractive');
    $('.onhover_metaimage').html('');
});

// Close when clicking outside
$(document).on('click','.modal-wrapper.open', function(event) {
  if ($(event.target).closest('.modal').length === 0) {
    $('.modal-wrapper').removeClass('open');
  }
  event.stopPropagation();
});

$(document).ready(function() {
  $('.highlights-wrapper').owlCarousel({
    loop:true,
    slideTransition: 'linear',
    autoplaySpeed: 3200,
    autoplayTimeout: 3200,
    margin:12,
    responsiveClass:true,
    stagePadding: 60,
    nav: false,
    dots: false,
    autoWidth:true,
    autoplay:true,
    autoplayHoverPause:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:3
        },
        1000:{
            items:5
        }
    }
  });
  
  var $owl = $('.featured-collection-carousel-wrapper').owlCarousel({
    loop:true,
    margin:20,
    stagePadding: 60,
    nav: true,
    responsiveClass:true,
    dots: false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:3
        },
        1000:{
            items:5
        }
    }
  });
  
  var wysiwyg_owloptions = {
    items:1,
         margin:10,
    stagePadding: 60,
    nav: false,
    responsiveClass:true,
    dots: false
  }
  
  function owlResize($owl) {
      $owl.trigger('destroy.owl.carousel');
      $owl.html($owl.find('.owl-stage-outer').html()).removeClass('owl-loaded');
      $owl.owlCarousel(wysiwyg_owloptions);
  }
  
  var $owl2 = $('.collection-list-carousel').owlCarousel({
    loop:true,
    margin:20,
    responsiveClass:true,
    stagePadding: 60,
    nav: false,
    dots: false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:3
        }
    }
  });
  
  $('.logo_list_wrapper .logo-bar').addClass('owl-carousel');
  $('.logo_list_wrapper .logo-bar.owl-carousel').owlCarousel({
    loop:true,
    margin:20,
    responsiveClass:true,
    nav: false,
    dots: false,
    slideTransition: 'linear',
    autoplaySpeed: 3200,
    autoplayTimeout: 3200,
    autoplay:true,
    autoplayHoverPause:true,
    responsive:{
        0:{
            loop:true,
            center: true,
            items:1,
            margin: 20,
            stagePadding: 100
        },
        600:{
            items:4
        },
        1000:{
            items:6
        }
    }
  });
  $('.slider-text-image-row-wrapper-carousel').owlCarousel({
    loop:true,
    responsiveClass:true,
    nav: false,
    dots: true,
    items:1
  });
  $(window).on("resize", function (e) {
      checkScreenSize();
  });
  // $(window).on("load", function (e) {
  //   $('.boost-sd__filter-tree-toggle-button--expand').click();
  // });
  checkScreenSize();
  
  function checkScreenSize(){
    var newWindowWidth = $(window).width();
    if (newWindowWidth >= 768 && newWindowWidth < 1260) {
      wysiwyg_owloptions = {
        items:3,
         margin:10,
        stagePadding: 60,
        nav: false,
        responsiveClass:true,
        dots: false
      }
      setTimeout(() => {   
        owlResize($owl); 
        owlResize($owl2);
      }, 400);
    }
    if (newWindowWidth < 768) {
      $('ul.info-tabs').addClass('owl-carousel');
      $('ul.info-tabs.owl-carousel').owlCarousel({
        responsiveClass:true,
        nav: false,
        dots: false,
        items:1,
        margin: 20,
        stagePadding: 80
      });
      var indexOwl = $('ul.info-tabs.owl-carousel').find('.info-block-list-item.active').attr('index_number');
      console.log(indexOwl, 'indexOwl')
      indexOwl = parseInt(indexOwl) - 1;
      $('ul.info-tabs.owl-carousel').trigger('to.owl.carousel', [indexOwl, 500, true]);
      
      setTimeout(() => {   
        owlResize($owl); 
        owlResize($owl2);
      }, 400);
      $('.logo_list_wrapper .logo-bar').addClass('owl-carousel');
      $('.logo_list_wrapper .logo-bar.owl-carousel').owlCarousel({
        loop:true,
        responsiveClass:true,
        nav: false,
        dots: false,
        center: true,
        items:1,
        margin: 20,
        stagePadding: 100
      });

      $('.rnw-nxt-race-sec-column.images-column').addClass('owl-carousel');
      $('.rnw-nxt-race-sec-column.images-column.owl-carousel').owlCarousel({
        loop:true,
        responsiveClass:true,
        nav: false,
        dots: false,
        center: true,
        items:1,
        margin: 20,
        stagePadding: 60
      });      


      $('.product-single__meta .arne-color-swatch-containers').addClass('owl-carousel');
      $('.product-single__meta .arne-color-swatch-containers.owl-carousel').owlCarousel({
        loop:false,
        responsiveClass:true,
        nav: false,
        dots: false,
        items: 4,
        margin: 6,
        stagePadding: 50
      });  
      
    } else {
      // $('.logo_list_wrapper .logo-bar ').removeClass('owl-carousel');
      $('.rnw-nxt-race-sec-column.images-column').removeClass('owl-carousel');
      $('.product-single__meta .arne-color-swatch-containers').removeClass('owl-carousel');
    }
  }  
	
  $('ul.tabs li').click(function(){
      var tab_id = $(this).attr('data-tab');

      $('ul.tabs li').removeClass('current');
      $('.tab-content').removeClass('current');

      $('.tab-content').css('opacity', '0');
      $(this).addClass('current');
      $("#"+tab_id).addClass('current');

    setTimeout(function(){
      $('.tab-content').css('opacity', '1');
    }, 250);
  });
    
  $('.readmore').click(function (event) {
    event.preventDefault();
    $(this).parents('.Rte').find('.product-description-full').show();
    $(this).parents('.Rte').find('.product-description-short').hide();
  });
  $('.readless').click(function (event) {
    event.preventDefault();    
    $(this).parents('.Rte').find('.product-description-full').hide();
    $(this).parents('.Rte').find('.product-description-short').show();
  }); 

  $(".desc_inner_wrp .dflex_wrp, .event-price-clmn-inner h2").click(function(){
    $(this).siblings(".rte").slideToggle();
  });
  $(".event-price-clmn-inner h2").click(function(){
    $(this).siblings(".collapse_container").slideToggle();
  });
  $(".rnw-fundraise-sec h2").click(function(){
    $(this).siblings(".rte_event").slideToggle();
  });
  $(".rnw-eco-water-sec h2").click(function(){
    $(this).siblings(".inner_desc_ele").slideToggle();
  });  
  $(".rnw-event-travel-sec-col_right-sub-content").click(function(){
    $(this).siblings(".rt_event").slideToggle();
  });  
})

$(document).on('click', '.metaproducts_ele .variant-input', function(event) {
    var vl = $(this).attr('data-value');
    $('.arne-color-swatch-element').removeClass('disabled_div');
    $('.arne-color-swatch-element').each(function() {
      var x = JSON.parse($(this).find('script').html());
      var that = $(this);
      var vav = false;
    
      var hr = that.attr('rel_handle');
      x.forEach(function(v, i) {
        if (v.option1 == vl || v.option2 == vl || v.option3 == vl) {
          if (v.available) {} else {
            that.addClass('disabled_div');
          }
          vav = true;
          if (that.hasClass('active')) {} else {
            var hrl = hr+'?variant='+v.id;

            if (vl == v.title) {
              that.find('a').attr('href', hrl);
            }
          }
        }
      });
      if (vav) {
      } else {
        that.addClass('disabled_div');
      }
    });
});




(function() {
    var initPhotoSwipeFromDOM = function(gallerySelector) {
        var parseThumbnailElements = function(el) {
            var thumbElements = el.childNodes,
                numNodes = thumbElements.length,
                items = [],
                el,
                childElements,
                thumbnailEl,
                size,
                item;

            for(var i = 0; i < numNodes; i++) {
                el = thumbElements[i];

                // include only element nodes 
                if(el.nodeType !== 1) {
                  continue;
                }

                childElements = el.children;

                size = el.getAttribute('data-size').split('x');

                // create slide object
                item = {
                    src: el.getAttribute('href'),
                    w: parseInt(size[0], 10),
                    h: parseInt(size[1], 10),
                    author: el.getAttribute('data-author'),
                    title: el.getAttribute('data-title')
                };

                item.el = el; // save link to element for getThumbBoundsFn

                if(childElements.length > 0) {
                  item.msrc = childElements[0].getAttribute('src'); // thumbnail url
                  if(childElements.length > 1) {
                      item.title = childElements[1].innerHTML; // caption (contents of figure)
                  }
                }


                var mediumSrc = el.getAttribute('data-med');
                if(mediumSrc) {
                    size = el.getAttribute('data-med-size').split('x');
                    // "medium-sized" image
                    item.m = {
                        src: mediumSrc,
                        w: parseInt(size[0], 10),
                        h: parseInt(size[1], 10)
                    };
                }
                // original image
                item.o = {
                    src: item.src,
                    w: item.w,
                    h: item.h
                };

                items.push(item);
            }

            return items;
        };

        // find nearest parent element
        var closest = function closest(el, fn) {
            return el && ( fn(el) ? el : closest(el.parentNode, fn) );
        };

        var onThumbnailsClick = function(e) {
            e = e || window.event;
            e.preventDefault ? e.preventDefault() : e.returnValue = false;

            var eTarget = e.target || e.srcElement;

            var clickedListItem = closest(eTarget, function(el) {
                return el.tagName === 'A';
            });

            if(!clickedListItem) {
                return;
            }

            var clickedGallery = clickedListItem.parentNode;

            var childNodes = clickedListItem.parentNode.childNodes,
                numChildNodes = childNodes.length,
                nodeIndex = 0,
                index;

            for (var i = 0; i < numChildNodes; i++) {
                if(childNodes[i].nodeType !== 1) { 
                    continue; 
                }

                if(childNodes[i] === clickedListItem) {
                    index = nodeIndex;
                    break;
                }
                nodeIndex++;
            }

            if(index >= 0) {
              console.log()
                openPhotoSwipe( index, clickedGallery );
            }
            return false;
        };

        var photoswipeParseHash = function() {
            var hash = window.location.hash.substring(1),
            params = {};

            if(hash.length < 5) { // pid=1
                return params;
            }

            var vars = hash.split('&');
            for (var i = 0; i < vars.length; i++) {
                if(!vars[i]) {
                    continue;
                }
                var pair = vars[i].split('=');  
                if(pair.length < 2) {
                    continue;
                }           
                params[pair[0]] = pair[1];
            }

            if(params.gid) {
                params.gid = parseInt(params.gid, 10);
            }

            return params;
        };

        var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
            var pswpElement = document.querySelectorAll('.pswp')[0],
                gallery,
                options,
                items;

            items = parseThumbnailElements(galleryElement);

            // define options (if needed)
            options = {

                galleryUID: galleryElement.getAttribute('data-pswp-uid'),

                getThumbBoundsFn: function(index) {
                    // See Options->getThumbBoundsFn section of docs for more info
                    var thumbnail = items[index].el.children[0],
                        pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                        rect = thumbnail.getBoundingClientRect(); 

                    return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                },

                addCaptionHTMLFn: function(item, captionEl, isFake) {
                    if(!item.title) {
                        captionEl.children[0].innerText = '';
                        return false;
                    }
                    captionEl.children[0].innerHTML = item.title +  '<br/><small>Photo: ' + item.author + '</small>';
                    return true;
                }
                
            };


            if(fromURL) {
                if(options.galleryPIDs) {
                    // parse real index when custom PIDs are used 
                    // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                    for(var j = 0; j < items.length; j++) {
                        if(items[j].pid == index) {
                            options.index = j;
                            break;
                        }
                    }
                } else {
                    options.index = parseInt(index, 10) - 1;
                }
            } else {
                options.index = parseInt(index, 10);
            }

            // exit if index not found
            if( isNaN(options.index) ) {
                return;
            }



            var radios = document.getElementsByName('gallery-style');
            for (var i = 0, length = radios.length; i < length; i++) {
                if (radios[i].checked) {
                    if(radios[i].id == 'radio-all-controls') {

                    } else if(radios[i].id == 'radio-minimal-black') {
                        options.mainClass = 'pswp--minimal--dark';
                        options.barsSize = {top:0,bottom:0};
                        options.captionEl = false;
                        options.fullscreenEl = false;
                        options.shareEl = false;
                        options.bgOpacity = 0.85;
                        options.tapToClose = true;
                        options.tapToToggleControls = false;
                    }
                    break;
                }
            }

            if(disableAnimation) {
                options.showAnimationDuration = 0;
            }

            // Pass data to PhotoSwipe and initialize it
            gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);

            // see: http://photoswipe.com/documentation/responsive-images.html
            var realViewportWidth,
                useLargeImages = false,
                firstResize = true,
                imageSrcWillChange;

            gallery.listen('beforeResize', function() {

                var dpiRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
                dpiRatio = Math.min(dpiRatio, 2.5);
                realViewportWidth = gallery.viewportSize.x * dpiRatio;


                if(realViewportWidth >= 1200 || (!gallery.likelyTouchDevice && realViewportWidth > 800) || screen.width > 1200 ) {
                    if(!useLargeImages) {
                        useLargeImages = true;
                        imageSrcWillChange = true;
                    }
                    
                } else {
                    if(useLargeImages) {
                        useLargeImages = false;
                        imageSrcWillChange = true;
                    }
                }

                if(imageSrcWillChange && !firstResize) {
                    gallery.invalidateCurrItems();
                }

                if(firstResize) {
                    firstResize = false;
                }

                imageSrcWillChange = false;

            });

            gallery.listen('gettingData', function(index, item) {
                if( useLargeImages ) {
                    item.src = item.o.src;
                    item.w = item.o.w;
                    item.h = item.o.h;
                } else {
                    item.src = item.m.src;
                    item.w = item.m.w;
                    item.h = item.m.h;
                }
            });

            gallery.init();
        };

        // select all gallery elements
        var galleryElements = document.querySelectorAll( gallerySelector );
        for(var i = 0, l = galleryElements.length; i < l; i++) {
            galleryElements[i].setAttribute('data-pswp-uid', i+1);
            galleryElements[i].onclick = onThumbnailsClick;
        }

        // Parse URL and open gallery if it contains #&pid=3&gid=1
        var hashData = photoswipeParseHash();
        if(hashData.pid && hashData.gid) {
            openPhotoSwipe( hashData.pid,  galleryElements[ hashData.gid - 1 ], true, true );
        }
    };

    initPhotoSwipeFromDOM('.demo-gallery');
})();

